<script setup lang="ts">
import IconAetosky from './IconAetosky.vue'
import IconAetoskyRail from './IconAetoskyRail.vue'
import config from '@/config'
import { customLogoUrl } from '@/utils/brand'

withDefaults(defineProps<{ variant?: 'full' | 'rail' }>(), { variant: 'full' })

const logoUrl = customLogoUrl()
</script>

<template>
  <img
    v-if="logoUrl"
    :src="logoUrl"
    :alt="config.appName || 'Aetos Terra'"
    class="app-logo"
    :class="variant === 'rail' ? 'app-logo--rail' : 'app-logo--full'"
  />
  <IconAetoskyRail v-else-if="variant === 'rail'" />
  <IconAetosky v-else />
</template>

<style scoped>
.app-logo {
  display: block;
  width: auto;
  object-fit: contain;
  color: #ffffff;
}

.app-logo--full {
  height: 22px;
  max-width: 140px;
}

.app-logo--rail {
  height: 20px;
  max-width: 34px;
}
</style>
